export default class UploadCancelledError extends Error {
    constructor(message = 'Upload cancelled') {
        super(message);
        this.name = this.constructor.name;
        this.disableDefaultHandling = true;
    }
}
